export const getNedarimConstants = () => {
    const allowedEvents = ['TransactionResponse', 'ValidateFields'];
    const origin = 'https://matara.pro';
    const iframeId = 'nedarimIframe';
    return { allowedEvents, origin, iframeId };
};
